import { checkLeadSession } from '@/features/leadBanner';
import { shouldHideGiftCertificatesBanner } from '../lib/shouldHideGiftCertificatesBanner';
import { getA51Placement } from '../model/a51Placement';
import { SerpBannerId, type SerpBanner, type SerpBannersGrid, type SerpStaticBanner } from '../model/types';
import { useDreamTourLottery } from '../model/useDreamTourLottery';
import A51Banner from '../ui/A51Banner.vue';
import AppInstallBanner from '../ui/AppInstallBanner.vue';
import DreamTourBanner from '../ui/DreamTourBanner.vue';
import EmiratesBanner from '../ui/EmiratesBanner.vue';
import GiftCertificatesBanner from '../ui/GiftCertificatesBanner.vue';
import Hacks8Banner from '../ui/Hacks8Banner.vue';
import LearnDiscountBanner from '../ui/LearnDiscountBanner.vue';
import SerpLeadBanner from '../ui/SerpLeadBanner.vue';
import SubscribeBanner from '../ui/SubscribeBanner.vue';

export const SERP_BANNERS_GRID: SerpBannersGrid = { anchor: 5, step: 5 };

export const SERP_STATIC_BANNERS: readonly SerpStaticBanner[] = [
  { id: SerpBannerId.A51, cardPosition: 4, dynamicGrid: { anchor: 9, step: 5 } },
];

export const SERP_BANNERS_PRIORITY: readonly SerpBannerId[] = [
  SerpBannerId.Lead,
  SerpBannerId.Emirates,
  SerpBannerId.AppInstall,
  SerpBannerId.LearnDiscount,
  SerpBannerId.DreamTour,
  SerpBannerId.Hacks8,
  SerpBannerId.Subscribe,
  SerpBannerId.GiftCertificates,
];

export const SERP_BANNERS: Record<SerpBannerId, SerpBanner> = {
  [SerpBannerId.Lead]: {
    id: SerpBannerId.Lead,
    component: SerpLeadBanner,
    repeat: 'repeat',
    isEnabled: ({ isAlternativeSearch, isShortSerp }) => !isAlternativeSearch && !isShortSerp && !checkLeadSession(),
  },
  [SerpBannerId.Emirates]: {
    id: SerpBannerId.Emirates,
    component: EmiratesBanner,
    repeat: 'repeat',
    isEnabled: ({ isAlternativeSearch }) => !isAlternativeSearch,
  },
  [SerpBannerId.AppInstall]: {
    id: SerpBannerId.AppInstall,
    component: AppInstallBanner,
    repeat: 'repeat',
  },
  [SerpBannerId.LearnDiscount]: {
    id: SerpBannerId.LearnDiscount,
    component: LearnDiscountBanner,
    repeat: 'repeat',
  },
  [SerpBannerId.DreamTour]: {
    id: SerpBannerId.DreamTour,
    component: DreamTourBanner,
    repeat: 'repeat',
    isEnabled: () => useDreamTourLottery().lottery.value !== null,
    preload: () => useDreamTourLottery().load(),
  },
  [SerpBannerId.Hacks8]: {
    id: SerpBannerId.Hacks8,
    component: Hacks8Banner,
    repeat: 'repeat',
  },
  [SerpBannerId.Subscribe]: {
    id: SerpBannerId.Subscribe,
    component: SubscribeBanner,
    repeat: 'once',
  },
  [SerpBannerId.GiftCertificates]: {
    id: SerpBannerId.GiftCertificates,
    component: GiftCertificatesBanner,
    repeat: 'repeat',
    isEnabled: () => typeof window !== 'undefined' && !shouldHideGiftCertificatesBanner(window.location.pathname),
  },
  [SerpBannerId.A51]: {
    id: SerpBannerId.A51,
    component: A51Banner,
    repeat: 'once',
    isEnabled: ({ searchCriteria }) => getA51Placement(searchCriteria) !== null,
  },
};
